import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Container } from 'styled-bootstrap-grid';
import { useTheme } from 'styled-components';
import { useClickOutside } from '@/js/libs/use-click-outside';
import { usePrevious } from '@/js/libs/use-previous';
import Icons from '../../Elements/Icons';
import { FieldsFooter, Fields, ToggleIcon, Count, HeaderLeft, Icon, FilterItemHeader, FilterItemWrapper, HeaderFiltersWrapper, HeaderFiltersContainerWrapper, } from './styles';
export const HeaderFilterItem = ({ title, titleSub, icon, count = 0, toggleIcon, className, invalid, children, footer, disabled = false, onClose, onOpen, noPadding = false, alignRight = false, }) => {
    const theme = useTheme();
    const [isActive, setActive] = useState(false);
    const [refFields, hasClickedOutsideFields] = useClickOutside();
    const [refFieldsToggleBtn, hasClickedOutsideFieldsToggleBtn] = useClickOutside();
    const wasActive = usePrevious(isActive);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const toggleFields = React.useCallback(() => {
        if (!disabled) {
            setActive(!isActive);
        }
    }, [disabled, isActive]);
    React.useEffect(() => {
        if (hasClickedOutsideFields && hasClickedOutsideFieldsToggleBtn) {
            setActive(false);
        }
    }, [hasClickedOutsideFields, hasClickedOutsideFieldsToggleBtn]);
    // handle onClose
    React.useEffect(() => {
        if (onClose && typeof wasActive !== 'undefined' && wasActive && !isActive) {
            onClose();
        }
    }, [wasActive, isActive, count, onClose]);
    // handle onOpen
    React.useEffect(() => {
        if (onOpen && typeof wasActive !== 'undefined' && !wasActive && isActive) {
            onOpen();
        }
    }, [wasActive, isActive, count, onOpen]);
    return (_jsxs(FilterItemWrapper, { "$isActive": isActive, className: className, disabled: disabled, "data-testid": `${title.replace(' ', '')}-filter-button`, children: [_jsxs(FilterItemHeader, { onClick: toggleFields, ref: refFieldsToggleBtn, children: [_jsxs(HeaderLeft, { disabled: disabled, children: [_jsx(Icon, { disabled: disabled, children: icon }), title, titleSub && (_jsxs(_Fragment, { children: [":\u00A0", _jsx("b", { children: titleSub })] }))] }), invalid && _jsx(Icons.WarningCircleAlt, { color: theme.colors.critical100 }), !titleSub && !toggleIcon && (_jsx(Count, { "data-testid": 'filter-counter', "$number": count, children: count })), toggleIcon && _jsx(ToggleIcon, { disabled: disabled, children: toggleIcon })] }), _jsxs(Fields, { "data-testid": `${title}-filter-field`, "$alignRight": alignRight, "$active": isActive, ref: refFields, "$noPadding": noPadding, children: [children, footer && _jsx(FieldsFooter, { children: footer instanceof Function ? footer(setActive) : footer })] })] }));
};
const HeaderFilters = ({ children }) => _jsx(HeaderFiltersWrapper, { children: children });
export const HeaderFiltersContainer = ({ children }) => (_jsx(HeaderFiltersContainerWrapper, { children: _jsx(Container, { children: children }) }));
export default HeaderFilters;
